import { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { BatFigure } from '../BatFigure';

import classes from './DuskEntrance.module.scss';

const ENTRANCE_BAT_FLAPS = [
  { duration: 0.2, begin: 0 },
  { duration: 0.24, begin: -0.07 },
  { duration: 0.18, begin: -0.13 },
  { duration: 0.22, begin: -0.04 },
  { duration: 0.25, begin: -0.1 },
  { duration: 0.19, begin: -0.16 },
  { duration: 0.23, begin: -0.02 },
  { duration: 0.21, begin: -0.09 },
];

let hasEntrancePlayed = false;

export const DuskEntrance: FunctionComponent = () => {
  const [isPlaying, setIsPlaying] = useState(!hasEntrancePlayed);

  const finishedCountRef = useRef(0);

  useEffect(() => {
    hasEntrancePlayed = true;
  }, []);

  const animationEndHandler = useCallback(() => {
    finishedCountRef.current += 1;

    if (finishedCountRef.current === ENTRANCE_BAT_FLAPS.length) {
      setIsPlaying(false);
    }
  }, []);

  if (!isPlaying) {
    return null;
  }

  return (
    <div onAnimationEnd={animationEndHandler}>
      {ENTRANCE_BAT_FLAPS.map(({ duration, begin }, index) => (
        <div key={index} className={classes['dusk-entrance__bat']}>
          <div className={classes['dusk-entrance__flutter']}>
            <BatFigure flapDuration={duration} flapBegin={begin} />
          </div>
        </div>
      ))}
    </div>
  );
};
